import { Injectable } from '@angular/core';
import { MarcacaoConsultaPK } from '../../marcacao/marcacao-consulta/pks/marcacao-consulta-pk';
import { MarcacaoPK } from '../../marcacao/marcacao-procedimento/pks/marcacao-pk';
import { AbstractServicePublic } from '../../service/abstract.service.public';


@Injectable({
  providedIn: 'root'
})
export class RelatorioService extends AbstractServicePublic {

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'relatorios';
  }

  gerarComprovanteMarcacaoConsulta(marcacaoConsultaPk: MarcacaoConsultaPK): any {

    const httpOptions = {
      responseType: 'arraybuffer' as 'json'
    };

    return this.http.post(`${this.getBaseUrlPublic()}/gerarComprovanteMarcacao/consulta`, marcacaoConsultaPk, httpOptions);
  }

  gerarComprovanteMarcacaoProcedimento(marcacaoProcedimentoPk: MarcacaoPK, appAlias: string): any {

    const httpOptions = {
      responseType: 'arraybuffer' as 'json'
    };

    return this.http.post(`${this.getBaseUrlPublic()}/gerarComprovanteMarcacao/procedimento/${appAlias}`, marcacaoProcedimentoPk, httpOptions);
  }

 gerarComprovanteMarcacaoProcedimentos(marcacaoProcedimentoPkList: MarcacaoPK[] , appAlias: string): any {

    const httpOptions = {
      responseType: 'arraybuffer' as 'json'
    };

    return this.http.post(`${this.getBaseUrlPublic()}/gerarComprovanteMarcacao/procedimentos/${appAlias}`, marcacaoProcedimentoPkList, httpOptions);
  }


  gerarRecomendacoesMarcacaoProcedimento(marcacaoProcedimentoPk: MarcacaoPK): any {

    const httpOptions = {
      responseType: 'arraybuffer' as 'json'
    };

    return this.http.post(`${this.getBaseUrlPublic()}/gerarRecomendacoes/procedimento`, marcacaoProcedimentoPk, httpOptions);
  }

}
